/* !
 * jQuery information v1.0.0
 * Copyright 2023, Connecty Inc.
 */
(function($, FUNCTIONS){
	const checkYPattern = /^\d{4}$/;
	const checkHPattern = /.*html$/;
	const maps = FUNCTIONS.va.pathname.split('/');
	let dir, year, cat, defaultTxt;
	if (maps[1] === 'medical') {
		dir = '/medical/information/';
		console.log(maps[3]);
		console.log(checkHPattern.test(maps[3]));
		if (checkYPattern.test(maps[3])) {
			year = maps[3];
			cat = maps[4] ? maps[4] + '/' : '';
		} else if(checkHPattern.test(maps[3])){
			cat = '';
		} else {
			cat = maps[3] ? maps[3] + '/' : '';
		}
		defaultTxt = '掲載年';
	} else {
		dir = '/information/';
		if (checkYPattern.test(maps[2])) {
			year = maps[2];
			cat = maps[3] ? maps[3] + '/' : '';
		} else {
			cat = maps[2] ? maps[2] + '/' : '';
		}
		defaultTxt = 'すべての年';
	}

	$('.info-sideNav-list a').each(function(){
		if(this.href == location.href) $(this).addClass('color_txt3');
	});

	const infoYearGenerator = () => {
		const $earliestY = $('.rt_earliest_year');
		const $latestY = $('.rt_latest_year');
		let $body = $('.js-yearSelect');
		let catName = $('.rt_target_category').text();

		if ($body.length > 0 && $earliestY.length > 0 && $latestY.length) {
			const earliestY = Number($earliestY.text());
			const latestY = Number($latestY.text());
			let html = '';

			if (year) {
				if (cat && (cat != 'detail/')) {
					html += `<li class="mod-dropdown-item"><a href="${dir}${cat}">${defaultTxt}</a></li>`;
				} else {
					html += `<li class="mod-dropdown-item"><a href="${dir}">${defaultTxt}</a></li>`;
				}
				console.log(cat);
			}

			for (let i = latestY; i >= earliestY; i--) {
				if (cat != 'detail/') {
					html += `<li class="mod-dropdown-item"><a href="${dir}${i}/${cat}">${i}年</a></li>`;
				} else {
					html += `<li class="mod-dropdown-item"><a href="${dir}${i}/">${i}年</a></li>`;
				}
			}
			$body.append(html);

			if (year) {
				$('.js-yearSelect-top').find('span').text(`${year}年`);
				$('.js-catSelect-top').find('span').text(catName);
			}
			if (typeof(catName)) {
				$('.js-catSelect-top').find('span').text(catName);
			}
			if (!catName.length) {
		     	$('.js-catSelect-top').find('span').text('すべて');
		    }
		}
	};

	infoYearGenerator();


})(window.jQuery, window.FUNCTIONS);
